import { useMemo } from 'react';

import { collection, doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { useData } from '../contextProviders/DataProvider';
import { firestore } from '../firebase';
import { CourseTee } from '../types/Course';

interface CourseUsgaDocument {
  tees: CourseTee[];
  ghinCourseId: number;
  importedAt: unknown;
}

export default function useCourseUsgaData(courseId: string | undefined) {
  const { userState } = useData();

  const usgaRef = useMemo(() => {
    if (!courseId) return null;
    if (userState.status !== 'ready' || !userState.userProfile) return null;

    return doc(
      collection(firestore, 'course', courseId, 'usga'),
      'data'
    ) as DocumentReference<CourseUsgaDocument>;
  }, [courseId, userState.userProfile, userState.status]);

  const [usgaDoc, isUsgaDataLoading, usgaDataError] = useDocumentData<CourseUsgaDocument>(usgaRef);

  return {
    usgaTees: usgaDoc?.tees ?? null,
    ghinCourseId: usgaDoc?.ghinCourseId ?? null,
    isUsgaDataLoading,
    usgaDataError,
  };
}
